import type {ReactElement} from 'react';
import {Button, Size, Type} from '@Components/button';
import {Text, TextSize} from '@Components/text/text';
import {useAppDispatch} from '@/hooks';
import {clearErrorBanner} from '@Components/social-media-wizard/social-media-wizard-reducer';
import type {WizardReauthErrorBannerProps} from './wizard-reauth-error-banner.types';
import styles from './wizard-reauth-error-banner.module.scss';

export function WizardReauthErrorBanner({banner}: WizardReauthErrorBannerProps): ReactElement {
  const dispatch = useAppDispatch();

  const onReconnectClick = (reauthUrl: string): void => {
    // Accounts reload via the parent list's BroadcastChannel when the OAuth
    // popup actually completes; refetching here (before completion) would only
    // pull stale, still-unhealthy accounts.
    window.open(reauthUrl, '', 'width=600,height=600,top=0,scrollbars=yes');
    dispatch(clearErrorBanner());
  };

  return (
    <div className={styles.banner} role="alert">
      <Text className={styles.body} size={TextSize.MD} val={window.i18next.t('pmwjs_social_account_health_wizard_blocked_alert')} />
      <ul className={styles.accountList}>
        {banner.accounts.map((account) => (
          <li key={account.id} className={styles.accountRow}>
            <Text className={styles.accountName} size={TextSize.MD} val={account.name} />
            <Button
              type={Type.DANGER}
              size={Size.SMALL}
              text={window.i18next.t('pmwjs_social_account_health_reconnect_cta')}
              onClick={(): void => {
                onReconnectClick(account.reauthUrl);
              }}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}
